import { ReactNode } from 'react';
import { EventProvider } from './eventContext';
import { UserProvider } from './userContext';
import { AuthProvider, useAuth } from './authContext';
import { ParlayProvider } from './parlayContext';

/**
 * Combined store provider
 * Wraps EventProvider, UserProvider, AuthProvider, and ParlayProvider
 * Uses Firebase Auth for authentication
 */
interface StoreProviderProps {
  children: ReactNode;
}

export function StoreProvider({ children }: StoreProviderProps) {
  console.log('🏪 StoreProvider rendering...');
  
  return (
    <AuthProvider>
      <UserProvider>
        <EventProvider>
          <ParlayProvider>{children}</ParlayProvider>
        </EventProvider>
      </UserProvider>
    </AuthProvider>
  );
}

// Re-export hooks for convenience
export { useEvent } from './eventContext';
export { useUser } from './userContext';
export { useAuth };
export { useParlay } from './parlayContext';


